import { QUOTE_SETTINGS_CONFIG } from '../Quoting/QuoteSettings/quoteSettingsConfig';
import { ISettingsSideNavSection } from './settingsNavType';

export const DEAL_ROOM_SECTIONS = {
  dealRoomCreation: {
    key: 'dealRoomCreation',
    label: 'Deal Room Creation',
  },
} satisfies Record<string, ISettingsSideNavSection>;

export const INVOICE_SETTINGS_SECTIONS = {
  invoiceCreation: {
    key: 'invoiceCreation',
    label: 'Invoice Creation',
  },
  invoiceSending: {
    key: 'invoiceSending',
    label: 'Invoice Sending',
  },
  invoiceTerms: {
    key: 'invoiceTerms',
    label: 'Invoice Terms',
  },
  defaultInvoiceTerms: {
    key: 'defaultInvoiceTerms',
    label: 'Default Invoice Terms',
  },
  invoiceContactSettings: {
    key: 'invoiceContactSettings',
    label: 'Invoice Contact Settings',
  },
} satisfies Record<string, ISettingsSideNavSection>;

export const PAYMENTS_SECTIONS = {
  collectAutomatically: {
    key: 'collectAutomatically',
    label: 'Collect Automatically',
  },
  autoPaymentTiming: {
    key: 'autoPaymentTiming',
    label: 'Auto-Payment Timing',
  },
  allowPartialPayments: {
    key: 'allowPartialPayments',
    label: 'Allow Partial Payments',
  },
} satisfies Record<string, ISettingsSideNavSection>;

export const INVOICE_TEMPLATES_SECTIONS = {
  invoiceTemplates: {
    key: 'invoiceTemplates',
    label: 'Invoice Templates',
  },
} satisfies Record<string, ISettingsSideNavSection>;

export const ONBOARDING_SECTIONS = {
  gettingStarted: { key: 'gettingStarted', label: 'Getting Started' },
  configureCatalog: { key: 'configureCatalog', label: 'Configure Catalog' },
  loadHistoricalData: {
    key: 'loadHistoricalData',
    label: 'Load Historical Data',
  },
} satisfies Record<string, ISettingsSideNavSection>;

export const BILLING_SETTINGS_SECTIONS = {
  accountingPeriods: {
    key: 'accountingPeriods',
    label: 'Accounting Periods',
  },
} satisfies Record<string, ISettingsSideNavSection>;

export const REV_REC_SETTINGS_SECTIONS = {
  enableRevenueRecognition: {
    key: 'enableRevenueRecognition',
    label: 'Enable Revenue Recognition',
  },
} satisfies Record<string, ISettingsSideNavSection>;

export const QUOTE_EXPIRATION_SECTIONS = {
  quoteExpiration: {
    key: 'quoteExpiration',
    label: 'Quote Expiration',
  },
} satisfies Record<string, ISettingsSideNavSection>;

export const TENANT_SETTINGS_SECTIONS = {
  accountContact: {
    key: 'accountContact',
    label: 'Account & Contact Settings',
  },
  additional: { key: 'additional', label: 'Additional Settings' },
  languageLocale: {
    key: 'languageLocale',
    label: 'Language & Locale Settings',
  },
} satisfies Record<string, ISettingsSideNavSection>;

export const QUOTE_SETTINGS_SECTIONS = Object.fromEntries(
  QUOTE_SETTINGS_CONFIG.map(({ key, label, children }) => [
    key,
    { key, label, children },
  ]),
) satisfies Record<string, ISettingsSideNavSection>;
